import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import FormModal from 'flarum/common/components/FormModal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const PAGE_SIZE = 100;
const API_PAGE_SIZE = 500;
function attrs(item) {
  return item && item.attributes || {};
}
function normalizeText(value) {
  return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}
function csvEscape(value) {
  const s = String(value ?? '');
  return /[;"\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}
function splitCsvRows(text) {
  const rows = [];
  let row = '';
  let quoted = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (ch === '"') {
      if (quoted && text[i + 1] === '"') {
        row += '""';
        i++;
        continue;
      }
      quoted = !quoted;
      row += ch;
      continue;
    }
    if (!quoted && (ch === '\n' || ch === '\r')) {
      if (ch === '\r' && text[i + 1] === '\n') i++;
      if (row.trim()) rows.push(row);
      row = '';
      continue;
    }
    row += ch;
  }
  if (row.trim()) rows.push(row);
  return rows;
}
function parseCsvLine(line, delimiter) {
  const fields = [];
  let field = '';
  let quoted = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (quoted) {
      if (ch === '"') {
        if (line[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          quoted = false;
        }
      } else {
        field += ch;
      }
    } else if (ch === '"') {
      quoted = true;
    } else if (ch === delimiter) {
      fields.push(field);
      field = '';
    } else {
      field += ch;
    }
  }
  fields.push(field);
  return fields;
}
class DocumentModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.item = this.attrs.item || null;
    const a = attrs(this.item);
    this.groupName = a.groupName || '';
    this.reference = a.reference || '';
  }
  className() {
    return 'Modal--small';
  }
  title() {
    return this.item ? 'Modifier la documentation' : 'Ajouter une documentation';
  }
  content() {
    return m('.Modal-body', [m('.Form-group', [m('label', 'Groupe / marque'), m('input.FormControl', {
      value: this.groupName,
      placeholder: 'PIONEER',
      oninput: e => {
        this.groupName = e.target.value;
      }
    })]), m('.Form-group', [m('label', 'Référence'), m('input.FormControl', {
      value: this.reference,
      placeholder: 'PIONEER PD-91 Service Manual',
      oninput: e => {
        this.reference = e.target.value;
      }
    })]), m('.Form-group.Form-controls', m(Button, {
      type: 'submit',
      className: 'Button Button--primary',
      loading: this.loading
    }, this.item ? 'Enregistrer' : 'Ajouter'))]);
  }
  onsubmit(e) {
    e.preventDefault();
    const groupName = this.groupName.trim();
    const reference = this.reference.trim();
    if (!groupName || !reference) return;
    this.loading = true;
    const apiUrl = app.forum.attribute('apiUrl');
    const id = this.item ? String(this.item.id) : null;
    const data = {
      type: 'val-documents',
      attributes: {
        groupName,
        reference
      }
    };
    if (id) data.id = id;
    app.request({
      method: id ? 'PATCH' : 'POST',
      url: apiUrl + '/val-documents' + (id ? '/' + encodeURIComponent(id) : ''),
      body: {
        data
      }
    }).then(() => {
      this.loading = false;
      this.hide();
      if (typeof this.attrs.onsaved === 'function') {
        this.attrs.onsaved();
      }
    }, error => {
      this.loading = false;
      m.redraw();
      throw error;
    });
  }
}
class PdfUploadModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.item = this.attrs.item || null;
    const a = attrs(this.item);
    this.groupName = a.groupName || '';
    this.reference = a.reference || '';
    this.file = null;
  }
  className() {
    return 'Modal--small';
  }
  title() {
    return 'Ajouter un PDF';
  }
  content() {
    return m('.Modal-body', [m('.Form-group', [m('label', 'Groupe / marque'), m('input.FormControl', {
      value: this.groupName,
      disabled: !!this.item,
      oninput: e => {
        this.groupName = e.target.value;
      }
    })]), m('.Form-group', [m('label', 'Référence'), m('input.FormControl', {
      value: this.reference,
      disabled: !!this.item,
      oninput: e => {
        this.reference = e.target.value;
      }
    })]), m('.Form-group', [m('label', 'Fichier PDF'), m('input.FormControl', {
      type: 'file',
      accept: 'application/pdf,.pdf',
      onchange: e => {
        this.file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
      }
    })]), m('.Form-group.Form-controls', m(Button, {
      type: 'submit',
      className: 'Button Button--primary',
      loading: this.loading
    }, 'Ajouter le PDF'))]);
  }
  async onsubmit(e) {
    e.preventDefault();
    if (!this.file) {
      alert('Choisis un fichier PDF.');
      return;
    }
    const groupName = this.groupName.trim();
    const reference = this.reference.trim();
    if (!groupName || !reference) {
      alert('Groupe / marque et référence sont obligatoires.');
      return;
    }
    this.loading = true;
    m.redraw();
    try {
      let item = this.item;

      /*
       * Depuis le bouton global :
       * cherche une entrée existante identique.
       */
      if (!item) {
        item = (this.attrs.documents || []).find(candidate => {
          const a = attrs(candidate);
          return normalizeText(a.groupName).trim() === normalizeText(groupName).trim() && normalizeText(a.reference).trim() === normalizeText(reference).trim();
        });

        /*
         * Sinon on crée l'entrée du catalogue.
         */
        if (!item) {
          const created = await app.request({
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/val-documents',
            body: {
              data: {
                type: 'val-documents',
                attributes: {
                  groupName,
                  reference
                }
              }
            }
          });
          item = created.data;
        }
      }
      const form = new FormData();
      form.append('document_id', String(item.id));
      form.append('file', this.file, this.file.name);
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/val/moderation/documents/pdf',
        body: form,
        serialize: body => body
      });
      this.loading = false;
      this.hide();
      if (typeof this.attrs.onuploaded === 'function') {
        this.attrs.onuploaded();
      }
    } catch (error) {
      this.loading = false;
      m.redraw();
      throw error;
    }
  }
}
class DocumentAccessModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.item = vnode.attrs.item;
    this.files = (attrs(this.item).pdfFiles || []).slice();
    this.query = '';
    this.users = [];
    this.selectedUser = null;
    this.searching = false;
    this.loadingAccess = false;
    this.saving = false;
    this.granted = new Set();
    this.error = null;
    this.status = '';
  }
  className() {
    return 'Modal--medium ValDocumentAccessModal';
  }
  title() {
    const a = attrs(this.item);
    return 'Accès PDF — ' + [a.groupName || '', a.reference || ''].filter(Boolean).join(' ');
  }
  async searchUsers() {
    const q = this.query.trim();
    this.error = null;
    this.status = '';
    this.users = [];
    if (q.length < 2) {
      this.error = 'Saisir au moins 2 caractères.';
      m.redraw();
      return;
    }
    this.searching = true;
    m.redraw();
    try {
      const payload = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/val/moderation/documents/access/users?q=' + encodeURIComponent(q)
      });
      this.users = Array.isArray(payload.users) ? payload.users : [];
      if (!this.users.length) {
        this.status = 'Aucun membre trouvé.';
      }
    } catch (error) {
      this.error = 'Impossible de rechercher les membres.';
    } finally {
      this.searching = false;
      m.redraw();
    }
  }
  async selectUser(user) {
    this.selectedUser = user;
    this.granted = new Set();
    this.error = null;
    this.status = '';
    this.loadingAccess = true;
    m.redraw();
    try {
      const fileIds = this.files.map(file => String(file.id)).join(',');
      const payload = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/val/moderation/documents/access' + '?user_id=' + encodeURIComponent(String(user.id)) + '&file_ids=' + encodeURIComponent(fileIds)
      });
      this.granted = new Set((payload.grantedFileIds || []).map(id => Number(id)));
    } catch (error) {
      this.error = 'Impossible de charger les droits de ce membre.';
    } finally {
      this.loadingAccess = false;
      m.redraw();
    }
  }
  async setAccess(files, grant) {
    if (!this.selectedUser || !files.length) return;
    this.error = null;
    this.status = '';
    this.saving = true;
    m.redraw();
    try {
      const fileIds = files.map(file => String(file.id));
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/val/moderation/documents/access/' + (grant ? 'grant' : 'revoke'),
        body: {
          user_id: String(this.selectedUser.id),
          file_ids: fileIds
        }
      });
      const next = new Set(this.granted);
      for (const file of files) {
        const id = Number(file.id);
        if (grant) {
          next.add(id);
        } else {
          next.delete(id);
        }
      }
      this.granted = next;
      this.status = grant ? files.length > 1 ? 'Accès accordés.' : 'Accès accordé.' : files.length > 1 ? 'Accès révoqués.' : 'Accès révoqué.';
    } catch (error) {
      this.error = grant ? 'Impossible d’accorder cet accès.' : 'Impossible de révoquer cet accès.';
    } finally {
      this.saving = false;
      m.redraw();
    }
  }
  content() {
    return m('.Modal-body', [m('.Form-group', [m('label', 'Rechercher un membre'), m('.ValDocumentAccessSearch', [m('input.FormControl', {
      type: 'search',
      placeholder: 'Pseudo, adresse mail ou identifiant…',
      value: this.query,
      oninput: event => {
        this.query = event.target.value;
      },
      onkeydown: event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.searchUsers();
        }
      }
    }), m(Button, {
      className: 'Button Button--primary',
      loading: this.searching,
      disabled: this.searching,
      onclick: () => this.searchUsers()
    }, 'Rechercher')])]), this.error ? m('.Alert.Alert--error', this.error) : null, this.status ? m('.Alert.Alert--success', this.status) : null, this.users.length ? m('.Form-group', [m('label', 'Résultats'), m('.ValDocumentAccessUsers', this.users.map(user => m(Button, {
      className: 'Button ' + (this.selectedUser && Number(this.selectedUser.id) === Number(user.id) ? 'Button--primary' : ''),
      onclick: () => this.selectUser(user)
    }, (user.displayName || user.username || 'Membre #' + user.id) + ' — #' + user.id)))]) : null, this.selectedUser ? m('.Form-group', [m('h3', 'Droits de ' + (this.selectedUser.displayName || this.selectedUser.username || 'membre #' + this.selectedUser.id)), this.loadingAccess ? m(LoadingIndicator) : this.files.length ? [m('.ValDocumentAccessBulk', [m(Button, {
      className: 'Button Button--primary',
      disabled: this.saving,
      onclick: () => this.setAccess(this.files, true)
    }, 'Tout accorder'), m(Button, {
      className: 'Button',
      disabled: this.saving,
      onclick: () => this.setAccess(this.files, false)
    }, 'Tout révoquer')]), m('.ValDocumentAccessFiles', this.files.map(file => {
      const granted = this.granted.has(Number(file.id));
      return m('.ValDocumentAccessFile', [m('.ValDocumentAccessFileName', [m('strong', file.filename || 'PDF #' + file.id), m('span.helpText', granted ? 'Accès autorisé' : 'Accès non autorisé')]), m(Button, {
        className: 'Button ' + (granted ? 'Button--danger' : 'Button--primary'),
        disabled: this.saving,
        onclick: () => this.setAccess([file], !granted)
      }, granted ? 'Révoquer' : 'Accorder')]);
    }))] : m('.helpText', 'Cette entrée ne possède aucun PDF.')]) : null]);
  }
}
export default class DocumentsPane {
  oninit() {
    this.loading = true;
    this.error = null;
    this.total = 0;
    this.documents = [];
    this.search = '';
    this.letter = '';
    this.page = 1;
    this.importing = false;
    this.importStatus = '';
    this.requestsLoading = true;
    this.requestsError = null;
    this.requests = [];
    this.requestCounts = {
      pending: 0,
      partial: 0,
      review: 0,
      complete: 0,
      rejected: 0
    };
    this.grantingRequestId = null;
    this.openingRequestId = null;
    this.purgingRequests = false;
    this.rejectingRequestId = null;
    this.showProcessedRequests = false;
    this.selectedRequestIds = new Set();
    this.loadCatalogue();
    this.loadRequests();
  }
  async loadCatalogue() {
    this.loading = true;
    this.error = null;
    const apiUrl = app.forum.attribute('apiUrl');
    try {
      const first = await app.request({
        method: 'GET',
        url: apiUrl + '/val-documents?page[limit]=' + API_PAGE_SIZE + '&page[offset]=0'
      });
      const firstData = Array.isArray(first.data) ? first.data : [];
      const total = first.meta && first.meta.page && typeof first.meta.page.total !== 'undefined' ? Number(first.meta.page.total) : firstData.length;
      const requests = [];
      for (let offset = API_PAGE_SIZE; offset < total; offset += API_PAGE_SIZE) {
        requests.push(app.request({
          method: 'GET',
          url: apiUrl + '/val-documents?page[limit]=' + API_PAGE_SIZE + '&page[offset]=' + offset
        }));
      }
      const rest = await Promise.all(requests);
      this.documents = firstData.concat(...rest.map(payload => Array.isArray(payload.data) ? payload.data : []));
      this.total = total;
      this.sortDocuments();
      await this.loadPdfFiles();
      this.loading = false;
      m.redraw();
    } catch (error) {
      this.error = error;
      this.loading = false;
      m.redraw();
    }
  }
  async loadPdfFiles() {
    const payload = await app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/val/moderation/documents/files'
    });
    const byDocument = {};
    for (const file of payload.files || []) {
      const id = String(file.documentId);
      if (!byDocument[id]) {
        byDocument[id] = [];
      }
      byDocument[id].push(file);
    }
    for (const item of this.documents) {
      const a = attrs(item);
      a.pdfFiles = byDocument[String(item.id)] || [];
    }
  }
  sortDocuments() {
    this.documents.sort((left, right) => {
      const a = attrs(left);
      const b = attrs(right);
      return String(a.groupName || '').localeCompare(String(b.groupName || ''), 'fr', {
        sensitivity: 'base',
        numeric: true
      }) || String(a.reference || '').localeCompare(String(b.reference || ''), 'fr', {
        sensitivity: 'base',
        numeric: true
      });
    });
  }
  filteredDocuments() {
    const q = normalizeText(this.search);
    return this.documents.filter(item => {
      const a = attrs(item);
      if (this.letter && String(a.letter || '').toUpperCase() !== this.letter) {
        return false;
      }
      if (!q) return true;
      return normalizeText((a.groupName || '') + ' ' + (a.reference || '')).includes(q);
    });
  }
  alphabet() {
    const letters = [''].concat('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''), ['*']);
    return m('.ValDocumentsModerationAlphabet', letters.map(letter => m('button', {
      type: 'button',
      className: 'Button Button--text ' + (this.letter === letter ? 'is-active' : ''),
      onclick: () => {
        this.letter = letter;
        this.page = 1;
      }
    }, letter || 'Tous')));
  }
  async loadRequests() {
    this.requestsLoading = true;
    this.requestsError = null;
    try {
      const payload = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/val/moderation/documents/requests?limit=250'
      });
      this.requests = payload && Array.isArray(payload.requests) ? payload.requests : [];
      this.requestCounts = payload && payload.counts && typeof payload.counts === 'object' ? payload.counts : {
        pending: 0,
        partial: 0,
        review: 0,
        complete: 0,
        rejected: 0
      };
    } catch (error) {
      console.error('[VAL Documents] chargement des demandes', error);
      this.requestsError = 'Impossible de charger les demandes de documentation.';
    } finally {
      this.requestsLoading = false;
      m.redraw();
    }
  }
  async purgeRequests() {
    if (this.purgingRequests) return;
    const ids = Array.from(this.selectedRequestIds || []).map(id => Number(id)).filter(id => id > 0);
    if (!ids.length) return;
    if (!confirm('Supprimer définitivement ' + ids.length + ' demande(s) sélectionnée(s) ?\n\n' + 'Les accès déjà accordés ne seront pas révoqués.')) {
      return;
    }
    this.purgingRequests = true;
    m.redraw();
    try {
      const payload = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/val/moderation/documents/requests/purge',
        body: {
          post_ids: ids.map(id => String(id))
        }
      });
      const purged = Number(payload && payload.purged ? payload.purged : 0);
      this.selectedRequestIds = new Set();
      await this.loadRequests();
      alert(purged ? purged + ' demande(s) supprimée(s).' : 'Aucune demande n’a été supprimée.');
    } catch (error) {
      console.error('[VAL Documents] purge demandes', error);
      alert('Impossible de purger la sélection.');
    } finally {
      this.purgingRequests = false;
      m.redraw();
    }
  }
  async grantRequest(request) {
    if (!request || this.grantingRequestId !== null) {
      return;
    }
    const postId = Number(request.postId);
    if (!postId) return;
    const action = request.status === 'partial' ? 'Accorder les accès manquants' : 'Accorder les accès';
    if (!confirm(action + ' à ' + request.username + ' pour cette demande ?')) {
      return;
    }
    this.grantingRequestId = postId;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/val/moderation/documents/requests/grant',
        body: {
          post_id: String(postId)
        }
      });
      await this.loadRequests();
    } catch (error) {
      console.error('[VAL Documents] accord demande', error);
      alert('Impossible d’accorder les accès pour cette demande.');
    } finally {
      this.grantingRequestId = null;
      m.redraw();
    }
  }
  async rejectRequest(request) {
    if (!request || this.rejectingRequestId !== null) {
      return;
    }
    const postId = Number(request.postId);
    if (!postId) return;
    if (!confirm('Refuser la demande de ' + (request.username || 'ce membre') + ' ?\n\n' + 'Les accès déjà accordés ne seront pas révoqués.')) {
      return;
    }
    this.rejectingRequestId = postId;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/val/moderation/documents/requests/reject',
        body: {
          post_id: String(postId)
        }
      });
      await this.loadRequests();
    } catch (error) {
      console.error('[VAL Documents] refus demande', error);
      alert('Impossible de refuser cette demande.');
    } finally {
      this.rejectingRequestId = null;
      m.redraw();
    }
  }
  async openRequestPost(request) {
    if (!request) return;
    const postId = Number(request.postId);
    if (!postId || this.openingRequestId !== null) {
      return;
    }
    this.openingRequestId = postId;
    m.redraw();
    try {
      const post = await app.store.find('posts', String(postId));
      m.route.set(app.route.post(post));
    } catch (error) {
      console.error('[VAL Documents] ouverture demande', error);
      alert('Impossible d’ouvrir le message de demande.');
    } finally {
      this.openingRequestId = null;
      m.redraw();
    }
  }
  formatRequestDate(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';
    const date = new Date(raw.includes('T') ? raw : raw.replace(' ', 'T') + 'Z');
    if (Number.isNaN(date.getTime())) {
      return raw;
    }
    return date.toLocaleString('fr-FR', {
      dateStyle: 'short',
      timeStyle: 'short'
    });
  }
  requestLineState(line) {
    if (!line) return '';
    if (line.state === 'matched') {
      return line.granted ? 'Accès accordé' : 'À accorder';
    }
    if (line.state === 'ambiguous') {
      return 'Référence ambiguë';
    }
    if (line.state === 'missing-files') {
      return 'Aucun PDF associé';
    }
    return 'Référence introuvable';
  }
  requestLineLabel(line) {
    if (!line) return '';
    if (line.state === 'matched' && line.groupName && line.reference) {
      return line.groupName + ' — ' + line.reference;
    }
    return line.text || '';
  }
  requestPanel() {
    const active = this.requests.filter(request => request.status !== 'complete' && request.status !== 'rejected');
    const processed = this.requests.filter(request => request.status === 'complete' || request.status === 'rejected');
    const complete = Number(this.requestCounts.complete || 0);
    const rejected = Number(this.requestCounts.rejected || 0);
    const processedCount = complete + rejected;
    const visible = this.showProcessedRequests ? processed : active;
    return m('.ValDocumentsRequests', [m('.ValDocumentsRequestsHeader', [m('div', [m('h3', this.showProcessedRequests ? 'Demandes traitées' : 'Demandes de documentations'), m('p.helpText', this.showProcessedRequests ? processed.length + ' demande(s) traitée(s) — ' + complete + ' acceptée(s), ' + rejected + ' refusée(s)' : active.length ? active.length + ' demande(s) à traiter' + (processedCount ? ' — ' + processedCount + ' traitée(s)' : '') : processedCount ? 'Aucune demande en attente — ' + processedCount + ' traitée(s)' : 'Aucune demande en attente')]), m('.ButtonGroup', [m(Button, {
      className: 'Button',
      icon: this.showProcessedRequests ? 'fas fa-inbox' : 'fas fa-history',
      disabled: this.requestsLoading || this.purgingRequests,
      onclick: () => {
        this.showProcessedRequests = !this.showProcessedRequests;
        this.selectedRequestIds = new Set();
      }
    }, this.showProcessedRequests ? 'Voir les demandes à traiter (' + active.length + ')' : 'Voir les demandes traitées (' + processedCount + ')'), !this.showProcessedRequests ? m(Button, {
      className: 'Button',
      icon: 'fas fa-trash-alt',
      loading: this.purgingRequests,
      disabled: this.purgingRequests || this.requestsLoading || !this.selectedRequestIds.size,
      onclick: () => this.purgeRequests()
    }, this.selectedRequestIds.size ? 'Purger la sélection (' + this.selectedRequestIds.size + ')' : 'Purger la sélection') : null, m(Button, {
      className: 'Button',
      icon: 'fas fa-sync-alt',
      loading: this.requestsLoading,
      disabled: this.requestsLoading || this.purgingRequests,
      onclick: () => this.loadRequests()
    }, 'Actualiser')])]), this.requestsError ? m('.Alert.Alert--error', this.requestsError) : null, this.requestsLoading && !this.requests.length ? m('.ValDocumentsRequestsLoading', m(LoadingIndicator)) : null, !this.requestsLoading && !visible.length && !this.requestsError ? m('.ValDocumentsRequestsEmpty.helpText', this.showProcessedRequests ? 'Aucune demande traitée.' : 'Toutes les demandes actuellement détectées sont traitées.') : null, visible.length ? m('.ValDocumentsRequestsList', visible.map(request => {
      const review = request.status === 'review';
      const partial = request.status === 'partial';
      const completed = request.status === 'complete';
      const refused = request.status === 'rejected';
      const postId = Number(request.postId);
      let className = '';
      if (review) {
        className = ' is-review';
      } else if (partial) {
        className = ' is-partial';
      } else if (completed) {
        className = ' is-complete';
      } else if (refused) {
        className = ' is-rejected';
      }
      return m('.ValDocumentsRequest', {
        className
      }, [m('.ValDocumentsRequestHead', [m('div', [!this.showProcessedRequests ? m('input.ValDocumentsRequestCheckbox', {
        type: 'checkbox',
        checked: this.selectedRequestIds.has(postId),
        disabled: this.purgingRequests,
        title: 'Sélectionner cette demande pour la purge',
        onchange: event => {
          const next = new Set(this.selectedRequestIds);
          if (event.target.checked) {
            next.add(postId);
          } else {
            next.delete(postId);
          }
          this.selectedRequestIds = next;
        }
      }) : null, m('strong.ValDocumentsRequestUser', request.username || 'Membre #' + request.userId), m('span.ValDocumentsRequestDate', this.formatRequestDate(request.createdAt))]), m('.ValDocumentsRequestProgress', refused ? 'Refusée' : completed ? 'Acceptée' : review ? 'À vérifier' : Number(request.grantedFiles || 0) + ' / ' + Number(request.matchedFiles || 0) + ' PDF accordé(s)')]), m('.ValDocumentsRequestLines', (request.lines || []).map(line => m('.ValDocumentsRequestLine', {
        className: line.state !== 'matched' ? ' has-problem' : line.granted ? ' is-granted' : ''
      }, [m('span.ValDocumentsRequestLineIcon', line.state !== 'matched' ? '!' : line.granted ? '✓' : '•'), m('span.ValDocumentsRequestLineText', this.requestLineLabel(line)), m('span.ValDocumentsRequestLineState', this.requestLineState(line))]))), m('.ValDocumentsRequestActions', [m(Button, {
        className: 'Button',
        icon: 'fas fa-comment-alt',
        loading: this.openingRequestId === postId,
        disabled: this.openingRequestId !== null,
        onclick: () => this.openRequestPost(request)
      }, 'Voir la demande'), this.showProcessedRequests ? m('span.helpText', refused ? 'Demande refusée' : 'Demande acceptée') : [review ? m('span.helpText', 'Une référence doit être vérifiée avant de pouvoir accorder automatiquement les accès.') : m(Button, {
        className: 'Button Button--primary',
        icon: 'fas fa-key',
        loading: this.grantingRequestId === postId,
        disabled: this.grantingRequestId !== null || this.rejectingRequestId !== null,
        onclick: () => this.grantRequest(request)
      }, partial ? 'Accorder le reste' : 'Accorder l’accès'), m(Button, {
        className: 'Button',
        icon: 'fas fa-ban',
        loading: this.rejectingRequestId === postId,
        disabled: this.rejectingRequestId !== null || this.grantingRequestId !== null,
        onclick: () => this.rejectRequest(request)
      }, 'Refuser')]])]);
    })) : null]);
  }
  manageAccess(item) {
    app.modal.show(DocumentAccessModal, {
      item
    });
  }
  uploadPdf(item) {
    if (item === void 0) {
      item = null;
    }
    app.modal.show(PdfUploadModal, {
      item,
      documents: this.documents,
      onuploaded: () => this.loadCatalogue()
    });
  }
  async removePdf(item, file) {
    if (!file) return;
    if (!confirm('Supprimer ce PDF ?\n\n' + file.filename + '\n\nL’entrée du catalogue sera conservée.')) {
      return;
    }
    await app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/val/moderation/documents/pdf/delete',
      body: {
        file_id: String(file.id)
      }
    });
    await this.loadCatalogue();
  }
  addDocument() {
    app.modal.show(DocumentModal, {
      onsaved: () => this.loadCatalogue()
    });
  }
  editDocument(item) {
    app.modal.show(DocumentModal, {
      item,
      onsaved: () => this.loadCatalogue()
    });
  }
  async deleteDocument(item) {
    const a = attrs(item);
    const pdfCount = (a.pdfFiles || []).length;
    const pdfWarning = pdfCount ? '\n\n' + pdfCount + ' PDF associé(s) seront également supprimés.' : '';
    if (!confirm('Supprimer définitivement cette entrée ?\n\n' + (a.groupName || '') + ' — ' + (a.reference || '') + pdfWarning)) {
      return;
    }
    const apiUrl = app.forum.attribute('apiUrl');
    try {
      await app.request({
        method: 'DELETE',
        url: apiUrl + '/val-documents/' + encodeURIComponent(String(item.id))
      });
      this.documents = this.documents.filter(candidate => String(candidate.id) !== String(item.id));
      this.total = Math.max(0, this.total - 1);
      m.redraw();
    } catch (error) {
      alert('La suppression a échoué.');
      throw error;
    }
  }
  exportCsv() {
    const rows = ['letter;group_name;reference', ...this.documents.map(item => {
      const a = attrs(item);
      return [csvEscape(a.letter || ''), csvEscape(a.groupName || ''), csvEscape(a.reference || '')].join(';');
    })];
    const blob = new Blob(['\uFEFF' + rows.join('\r\n')], {
      type: 'text/csv;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'val-documents.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
  async importCsvFile(file) {
    if (!file || this.importing) return;
    this.importing = true;
    this.importStatus = 'Lecture du CSV…';
    m.redraw();
    try {
      const text = await file.text();
      const rows = splitCsvRows(text);
      if (!rows.length) {
        throw new Error('CSV vide');
      }
      const delimiter = (rows[0].match(/;/g) || []).length >= (rows[0].match(/,/g) || []).length ? ';' : ',';
      const header = parseCsvLine(rows.shift(), delimiter).map(value => normalizeText(value.trim()));
      const groupAliases = ['group_name', 'groupe', 'marque', 'group'];
      const referenceAliases = ['reference', 'ref'];
      const groupIndex = header.findIndex(value => groupAliases.includes(value));
      const referenceIndex = header.findIndex(value => referenceAliases.includes(value));
      if (groupIndex < 0 || referenceIndex < 0) {
        throw new Error('Colonnes groupe/marque et référence introuvables');
      }
      const known = new Set(this.documents.map(item => {
        const a = attrs(item);
        return normalizeText(a.groupName).trim() + '\u0000' + normalizeText(a.reference).trim();
      }));
      const pending = [];
      let ignored = 0;
      for (const row of rows) {
        const fields = parseCsvLine(row, delimiter);
        const groupName = String(fields[groupIndex] || '').trim();
        const reference = String(fields[referenceIndex] || '').trim();
        if (!groupName || !reference) {
          ignored++;
          continue;
        }
        const key = normalizeText(groupName).trim() + '\u0000' + normalizeText(reference).trim();
        if (known.has(key)) {
          ignored++;
          continue;
        }
        known.add(key);
        pending.push({
          groupName,
          reference
        });
      }
      const apiUrl = app.forum.attribute('apiUrl');
      let created = 0;
      for (let i = 0; i < pending.length; i += 10) {
        const batch = pending.slice(i, i + 10);
        this.importStatus = 'Import : ' + Math.min(i + batch.length, pending.length) + ' / ' + pending.length + '…';
        m.redraw();
        await Promise.all(batch.map(entry => app.request({
          method: 'POST',
          url: apiUrl + '/val-documents',
          body: {
            data: {
              type: 'val-documents',
              attributes: entry
            }
          }
        })));
        created += batch.length;
      }
      this.importStatus = created + ' ajout(s), ' + ignored + ' ligne(s) ignorée(s).';
      await this.loadCatalogue();
    } catch (error) {
      console.error(error);
      this.importStatus = 'Import impossible : ' + (error && error.message ? error.message : 'erreur inconnue');
    } finally {
      this.importing = false;
      m.redraw();
    }
  }
  pagination(total) {
    var _this = this;
    const pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
    if (this.page > pages) {
      this.page = pages;
    }
    if (this.page < 1) {
      this.page = 1;
    }
    if (pages <= 1) return null;
    const current = this.page;
    const maxStart = Math.max(1, pages - 9);
    const start = Math.max(1, Math.min(current - 4, maxStart));
    const end = Math.min(pages, start + 9);
    const buttons = [];
    const button = function (label, page, disabled, active, title) {
      if (disabled === void 0) {
        disabled = false;
      }
      if (active === void 0) {
        active = false;
      }
      if (title === void 0) {
        title = '';
      }
      return m(Button, {
        className: active ? 'Button Button--primary' : 'Button',
        disabled,
        title,
        onclick: () => {
          _this.page = page;
        }
      }, label);
    };
    buttons.push(button('Début', 1, current <= 1, false, 'Première page'));
    buttons.push(button('‹', current - 1, current <= 1, false, 'Page précédente'));
    for (let page = start; page <= end; page++) {
      buttons.push(button(String(page), page, false, page === current, 'Page ' + page));
    }
    buttons.push(m('form.ValModerationPageJump', {
      onsubmit: event => {
        event.preventDefault();
        const input = event.currentTarget.querySelector('input');
        this.page = Math.max(1, Math.min(pages, Number(input?.value || current)));
      }
    }, [m('span', 'Page'), m('input.FormControl', {
      type: 'number',
      min: 1,
      max: pages,
      step: 1,
      value: current,
      'aria-label': 'Numéro de page'
    }), m('span', '/ ' + pages), m(Button, {
      type: 'submit'
    }, 'Aller')]));
    buttons.push(button('›', current + 1, current >= pages, false, 'Page suivante'));
    buttons.push(button('Dernière', pages, current >= pages, false, 'Dernière page'));
    return m('.ValDocumentsModerationPagination', buttons);
  }
  view() {
    if (this.loading) {
      return m('.ValModerationPane', m(LoadingIndicator));
    }
    if (this.error) {
      return m('.Alert.Alert--error', 'Impossible de charger le catalogue des documents.');
    }
    const filtered = this.filteredDocuments();
    const start = (this.page - 1) * PAGE_SIZE;
    const rows = filtered.slice(start, start + PAGE_SIZE);
    return m('.ValModerationPane.ValDocumentsModeration', [m('.ValModerationPaneHeader', [m('div', [m('h2', 'Documents'), m('p.helpText', this.total + ' références dans le catalogue technique.')]), m('.ValDocumentsModerationActions', [m(Button, {
      className: 'Button',
      icon: 'fas fa-file-pdf',
      onclick: () => this.uploadPdf()
    }, 'Téléverser PDF'), m('label.Button', {
      className: this.importing ? 'disabled' : ''
    }, [m('i.icon.fas.fa-file-import'), ' Importer CSV', m('input', {
      type: 'file',
      accept: '.csv,text/csv',
      disabled: this.importing,
      style: {
        display: 'none'
      },
      onchange: e => {
        const file = e.target.files && e.target.files[0];
        if (file) this.importCsvFile(file);
        e.target.value = '';
      }
    })]), m(Button, {
      className: 'Button',
      icon: 'fas fa-file-export',
      onclick: () => this.exportCsv()
    }, 'Exporter CSV'), m(Button, {
      className: 'Button Button--primary',
      icon: 'fas fa-plus',
      onclick: () => this.addDocument()
    }, 'Ajouter')])]), this.requestPanel(), this.importStatus ? m('.ValDocumentsModerationStatus.helpText', this.importStatus) : null, m('input.FormControl.ValDocumentsModerationSearch', {
      type: 'search',
      placeholder: 'Rechercher une marque, un modèle, une référence…',
      value: this.search,
      oninput: e => {
        this.search = e.target.value;
        this.page = 1;
      }
    }), this.alphabet(), m('.ValDocumentsModerationCount', filtered.length === this.total ? this.total + ' références' : filtered.length + ' référence(s) trouvée(s)'), m('.ValDocumentsModerationTableWrap', m('table.Table.ValDocumentsModerationTable', [m('thead', m('tr', [m('th', 'Lettre'), m('th', 'Groupe / marque'), m('th', 'Référence'), m('th', 'PDF'), m('th.ValDocumentsModerationActionsColumn', 'Actions')])), m('tbody', rows.length ? rows.map(item => {
      const a = attrs(item);
      return m('tr', [m('td', a.letter || ''), m('td', a.groupName || ''), m('td', a.reference || ''), m('td.ValDocumentsModerationPdfCell', (a.pdfFiles || []).length ? m('.ValDocumentsModerationPdfList', (a.pdfFiles || []).map(file => m('.ValDocumentsModerationPdfItem', [m('a.ValDocumentsModerationPdfName', {
        href: app.forum.attribute('apiUrl') + '/val/moderation/documents/pdf?file_id=' + encodeURIComponent(String(file.id)),
        target: '_blank'
      }, file.filename), app.session.user && app.session.user.isAdmin && app.session.user.isAdmin() ? m(Button, {
        className: 'Button Button--icon',
        icon: 'fas fa-times',
        title: 'Supprimer ce PDF',
        onclick: () => this.removePdf(item, file)
      }) : null]))) : m('span.helpText', '—')), m('td.ValDocumentsModerationActionsColumn', [m(Button, {
        className: 'Button Button--icon',
        icon: 'fas fa-pencil-alt',
        title: 'Modifier',
        onclick: () => this.editDocument(item)
      }), m(Button, {
        className: 'Button Button--icon',
        icon: 'fas fa-paperclip',
        title: 'Ajouter un PDF',
        onclick: () => this.uploadPdf(item)
      }), m(Button, {
        className: 'Button Button--icon',
        icon: 'fas fa-key',
        title: 'Gérer les accès PDF',
        disabled: !(a.pdfFiles || []).length,
        onclick: () => this.manageAccess(item)
      }), app.session.user && app.session.user.isAdmin && app.session.user.isAdmin() ? m(Button, {
        className: 'Button Button--icon',
        icon: 'fas fa-trash-alt',
        title: (a.pdfFiles || []).length ? 'Supprimer l’entrée et tous ses PDF' : 'Supprimer l’entrée',
        onclick: () => this.deleteDocument(item)
      }) : null])]);
    }) : m('tr', m('td.helpText', {
      colspan: 5,
      style: {
        textAlign: 'center',
        padding: '24px'
      }
    }, 'Aucune documentation ne correspond à cette recherche.')))])), this.pagination(filtered.length)]);
  }
}